module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_3_ADAC.56e73fd75789f415bdc642dbad0e28eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_3_ADAC.png
// module id = 780
// module chunks = 0